import { __rest, __assign } from 'tslib';
import React__default from 'react';
import { sheetFieldsSelector, advancedSearchCriteriasSelector, currentDataLocaleSelector, getBusinessFiltersForCurrentLocale, buildAdvancedFilterList } from '@keepeek/commons';
import { useRecoilValue } from 'recoil';
import { withSuspense } from '../withSuspense/index.js';
import BusinessFilterTypeSwitch from './BusinessFilterTypeSwitch.js';

var BusinessFilterAdvanced = function (_a) {
    var _b;
    var filter = _a.filter, dataViewKey = _a.dataViewKey, rest = __rest(_a, ["filter", "dataViewKey"]);
    var sheetFields = useRecoilValue(sheetFieldsSelector);
    var criterias = useRecoilValue(advancedSearchCriteriasSelector);
    var dataLocale = useRecoilValue(currentDataLocaleSelector);
    var businessFilter = getBusinessFiltersForCurrentLocale(buildAdvancedFilterList((_b = filter === null || filter === void 0 ? void 0 : filter.name) !== null && _b !== void 0 ? _b : "", sheetFields, criterias), dataLocale);
    if (!businessFilter || businessFilter.length === 0) {
        return null;
    }
    return (React__default.createElement(BusinessFilterTypeSwitch, __assign({ businessFilter: businessFilter[0], dataViewKey: dataViewKey, showElementCount: filter.showElementCount }, rest)));
};
var BusinessFilterAdvanced$1 = withSuspense(BusinessFilterAdvanced);

export { BusinessFilterAdvanced$1 as default };
//# sourceMappingURL=BusinessFilterAdvanced.js.map
